import { put, call, takeLatest, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import sitemapAPI from '../../api/sitemap';
import { Creators as GlobalCreators } from '../../reducers/global';
import { Types, Creators as SiteMapCreators } from '../../reducers/sitemap';
import getState from '../../utils/getState';

function* getBrands({ data }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const { limit = 10, filter, pageNumber = 1 } = data;
    const offset = pageNumber - 1 < 1 ? 0 : limit * (pageNumber - 1);
    const params = { limit, offset };

    if (filter && filter !== '*') {
      params.attributes = 'descricao';
      params.filter = filter;
    }

    const { items = [], totalPages, pageNumber: actualPage } = yield call(sitemapAPI.getBrands, params, siteId);

    if (isEmpty(data)) {
      throw 'SiteMap get brands not found';
    }

    yield put(
      SiteMapCreators.getBrandsSuccess({
        brands: items,
        pagination: { limit, offset, filter, pageNumber: actualPage, totalPages },
      })
    );
  } catch (error) {
    yield put(GlobalCreators.errorApp(error));
    yield put(SiteMapCreators.getBrandsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_BRANDS_REQUEST, getBrands);
}
